import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPartnerAccountToInvoiceCollectionMutationVariables = Types.Exact<{
  invoiceCollectionId: Types.Scalars['ID'];
  partnerAccountId: Types.Scalars['ID'];
}>;


export type AddPartnerAccountToInvoiceCollectionMutation = { __typename?: 'Mutation', addPartnerAccountToInvoiceCollection?: { __typename?: 'InvoiceCollection', id: string, partner_account_ids?: Array<string | null> | null } | null };


export const AddPartnerAccountToInvoiceCollectionDocument = gql`
    mutation AddPartnerAccountToInvoiceCollection($invoiceCollectionId: ID!, $partnerAccountId: ID!) {
  addPartnerAccountToInvoiceCollection(
    invoice_collection_id: $invoiceCollectionId
    partner_account_id: $partnerAccountId
  ) {
    id
    partner_account_ids
  }
}
    `;
export type AddPartnerAccountToInvoiceCollectionMutationFn = Apollo.MutationFunction<AddPartnerAccountToInvoiceCollectionMutation, AddPartnerAccountToInvoiceCollectionMutationVariables>;

/**
 * __useAddPartnerAccountToInvoiceCollectionMutation__
 *
 * To run a mutation, you first call `useAddPartnerAccountToInvoiceCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartnerAccountToInvoiceCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartnerAccountToInvoiceCollectionMutation, { data, loading, error }] = useAddPartnerAccountToInvoiceCollectionMutation({
 *   variables: {
 *      invoiceCollectionId: // value for 'invoiceCollectionId'
 *      partnerAccountId: // value for 'partnerAccountId'
 *   },
 * });
 */
export function useAddPartnerAccountToInvoiceCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddPartnerAccountToInvoiceCollectionMutation, AddPartnerAccountToInvoiceCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartnerAccountToInvoiceCollectionMutation, AddPartnerAccountToInvoiceCollectionMutationVariables>(AddPartnerAccountToInvoiceCollectionDocument, options);
      }
export type AddPartnerAccountToInvoiceCollectionMutationHookResult = ReturnType<typeof useAddPartnerAccountToInvoiceCollectionMutation>;
export type AddPartnerAccountToInvoiceCollectionMutationResult = Apollo.MutationResult<AddPartnerAccountToInvoiceCollectionMutation>;
export type AddPartnerAccountToInvoiceCollectionMutationOptions = Apollo.BaseMutationOptions<AddPartnerAccountToInvoiceCollectionMutation, AddPartnerAccountToInvoiceCollectionMutationVariables>;